export class ComprobantePago{
    Adjunto_CDR: string = "";
    Adjunto_CSV: string = "";
    Alta_Fecha: string = "";
    Cadena_Factura: string = "";
    Comprobante_Contabilizado: string = "";
    Comprobante_Emitido: string = "";
    Correo: string = "";
    Direccion_Fiscal: string = "";
    Estado: string = "";
    Fecha_Emision: string = "";
    Fecha_Vencimiento: string = "";
    IGV_Exonerado: number = 0.00;
    IGV_Importe: number = 0.00;
    IGV_Porcentaje: number = 0.00;
    Moneda: number = 0.00;
    Num_Doc_Identificacion: string = "";
    Numero: number = 0.00;
    Observacion: string = "";
    Observacion_CDR: string = "";
    Precio_Venta: number = 0.00;
    Razon_Social: string = "";
    Serie: string = "";
    TC_Compra: number = 0.00;
    TC_Venta: number = 0.00;
    Tipo_Comprobante: string = "";
    Tipo_Doc_Identificacion: number = 0.00;
    Tipo_Operacion: number = 0.00;
    Tipo_Pago: number = 0.00;
    Valor_Venta: number = 0.00;
    detail: any;
    idComprobanteIF: number = 0.00;
    idComprobanteIFRef: number = 0.00;
    idEmpresa: number = 0.00;
    idLocal: number = 0.00;
}